export default function ErrorBanner({ message, onRetry }) {
  if (!message) return null;
  return (
    <div className="alert alert-danger d-flex align-items-start gap-2 mb-3" role="alert">
      <span className="flex-shrink-0">✕</span>
      <span className="flex-grow-1 small">{message}</span>
      {onRetry && (
        <button onClick={onRetry} className="btn btn-link btn-sm p-0 text-danger text-decoration-underline flex-shrink-0">
          Retry
        </button>
      )}
    </div>
  );
}
